import React from 'react'
import styled from 'styled-components'
import Colors from '../assets/styles/Colors'
import DownloadGreyIcon from '../assets/icons/JSX/DownloadGreyIcon'
import Responsive from '../assets/config/Responsive'

const DownloadGreyButton: React.FC<{
  onClick?: (_: any) => void
  style?: React.CSSProperties
}> = ({ onClick, style }) => {
  return (
    <Btn style={style} type="button" onClick={onClick}>
      <DownloadGreyIcon />
    </Btn>
  )
}
//
//
const Btn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  width: 40px;
  height: 40px;
  transition: all 200ms ease-in-out;
  background-color: ${Colors.grey};
  padding: unset;
  svg {
    height: 40px !important;
    width: 40px !important;
  }
  span {
    color: ${Colors.primaryBlack};
    -webkit-text-fill-color: rgba(0, 0, 0, 1);
    -webkit-opacity: 1;
  }
  ${Responsive.mobile} {
    width: 32px;
    height: 32px;
    svg {
      height: 32px !important;
      width: 32px !important;
    }
  }

  /* hover styles */
  &:hover {
    transition: all 200ms ease-in-out;
    background-color: ${Colors.primaryBlack};
    color: ${Colors.white};
    span {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.primaryBlack}!important;
    }
    svg {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.primaryBlack}!important;
    }
    g path {
      fill: #ffffff;
    }
    rect {
      fill: ${Colors.primaryBlack};
    }
    ${Responsive.mobile} {
      background-color: ${Colors.grey};
      transition: all 200ms ease-in-out;
      color: ${Colors.primaryBlack};
      span {
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        color: ${Colors.primaryBlack}!important;
        -webkit-opacity: 1;
      }
      svg {
        color: ${Colors.primaryBlack}!important;
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
      g path {
        fill: ${Colors.primaryBlack};
      }
      rect {
        fill: ${Colors.grey};
      }
    }
    ${Responsive.tablet} {
      background-color: ${Colors.grey};
      transition: all 200ms ease-in-out;
      color: ${Colors.primaryBlack};
      span {
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        color: ${Colors.primaryBlack}!important;
        -webkit-opacity: 1;
      }
      svg {
        color: ${Colors.primaryBlack}!important;
        -webkit-text-fill-color: rgba(0, 0, 0, 1);
        -webkit-opacity: 1;
      }
      g path {
        fill: ${Colors.primaryBlack};
      }
      rect {
        fill: ${Colors.grey};
      }
    }
  }
  &:active {
    background-color: ${Colors.primaryBlack};
    color: ${Colors.white};
    opacity: 0.9;
    span {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    svg {
      -webkit-text-fill-color: #ffffff;
      color: ${Colors.white}!important;
    }
    g path {
      fill: #ffffff;
    }
    rect {
      fill: ${Colors.primaryBlack};
    }
  }
`

export default DownloadGreyButton
